/*
 * @Author: your name
 * @Date: 2021-04-14 14:47:17
 * @LastEditTime: 2023-03-30 08:43:16
 * @LastEditors: Json Chen
 * @Description: In User Settings Edit
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/tools.ts
 */

import { EnumLinkType } from '@/src/types/common/linkType';
import { EnumModuleType } from '@/src/types/common/module';
import { randomNumber } from 'src/tools/helper';
// import {router } from 'react-router';
import {
  EnumCollapseId,
  generateDefaultCarousel,
  generateDefaultLongCanvas,
  generateDefaultSEOSetting,
  ProductType,
} from './common';

import { getI18nFromGeneral } from '@/src/tools/tools';
import {
  generateBody,
  initContentBody,
  initContentError,
} from 'src/constrains/DraggableModules/tools';

const convertSpecificError = (specificErr) => {
  const _return = [];
  Object.values(specificErr || {}).forEach((err: string[]) => {
    _return.push(...(err || []));
  });
  return _return;
};

const convertDataFromServerToRedux = (response, isPrimary) => {
  const aliasUuid = window.location.pathname.split('/')[6] || '';
  const aliasSearch = window.location.search;
  const aliasLength = aliasSearch.substring(
    aliasSearch.lastIndexOf('=') + 1,
    aliasSearch.length,
  );
  const {
    productContent = {},
    product = {},
    salesChannel = {},
    originContent,
  } = response;
  const isNew = aliasUuid == 'new';
  const { hasError = false, productCode } = productContent;

  const {
    uuid = '',
    productType = '',
    products = [],
    variants = [],
    productName = '',
    product: productSingle,
  } = product;
  const { variantThumbnails: originVariantThumbnails = {} } =
    originContent || {};

  const originCarousel = originContent?.carousel?.carousel || {};
  const {
    currency = '',
    uuid: salesChannelUuid = '',
    name: salesChannelName = '',
  } = salesChannel;
  const aliasProductName = isNew
    ? `${productContent.productName || ''} Alias ${aliasLength}`
    : productContent.productName;
  const subtitle = productContent.subtitle || '';
  const description = productContent.description || '';
  const remarks = productContent.remarks || '';
  const { carousel: carouselServerData, sameAsOriginal } =
    productContent.carousel || {};
  const seo = productContent.seo || {};
  const contentUuid = productContent.uuid || {};
  const thumbnailImage = productContent.variantThumbnails;
  const contentModules = productContent.contentModules || [];
  const miniProgramShare = productContent.miniProgramShare || {};
  const miniProgramPageInfo = productContent.miniProgramPageInfo || {};

  const moduleContentOrder = [];
  const moduleContentStaticConfig = {};
  const moduleContentDynamicConfig = {};
  const collapseOpen = {
    [EnumCollapseId.seoSetting]: false,
    [EnumCollapseId.contentDetails]: false,
    [EnumCollapseId.carousel]: false,
    [EnumCollapseId.thumbnailImage]: false,
    [EnumCollapseId.miniProgramShare]: false,
    [EnumCollapseId.miniProgramPageInfo]: false,
  };
  const collapseErrorMsgDisplay = {
    [EnumCollapseId.seoSetting]: { hasError: false, display: !isNew },
    [EnumCollapseId.contentDetails]: { hasError: false, display: !isNew },
    [EnumCollapseId.carousel]: { hasError: false, display: !isNew },
    [EnumCollapseId.thumbnailImage]: { hasError: false, display: !isNew },
    [EnumCollapseId.miniProgramPageInfo]: { hasError: false, display: !isNew },
    [EnumCollapseId.miniProgramShare]: { hasError: false, display: !isNew },
  };
  initContentBody({
    contentBody: contentModules,
    moduleContentOrder,
    isNew,
    collapseOpen,
    collapseErrorMsgDisplay,
    moduleContentDynamicConfig,
    moduleContentStaticConfig,
  });

  const carouselData = calculateCarousel(
    carouselServerData,
    aliasUuid == 'new' ? true : sameAsOriginal,
  );
  const originCarouselData = calculateCarousel(originCarousel, sameAsOriginal);
  const skuData = ((productSingle ? [productSingle] : products) || []).map(
    (item) => item.sku,
  );
  const codeData = ((productSingle ? [productSingle] : products) || []).map(
    (item) =>
      [...[item.barcode], ...[...(item.codes || []).map((i) => i.title)]].join(
        ' ',
      ),
  );
  const contentPrice = [];
  (products || []).forEach((item) => {
    contentPrice.push(item.defaultSalePrice || '');
  });
  const thumbnailImageData = {
    sameAsOriginal:
      (thumbnailImage || {}).sameAsOriginal === false ? false : true,
    linkModules: calculateLinkModules(products, thumbnailImage, variants),
  };
  const originalThumbnailImage = {
    sameAsOriginal: (originVariantThumbnails || {}).sameAsOriginal || false,
    linkModules: calculateLinkModules(
      products,
      originVariantThumbnails,
      variants,
    ),
  };
  let original = {};
  if (aliasUuid == 'new') {
    original = {
      carousel: carouselData,
      thumbnailImage: thumbnailImageData,
    };
  } else {
    original = {
      carousel: originCarouselData,
      thumbnailImage: originalThumbnailImage,
    };
  }
  const isMulti =
    productType == ProductType.MultiplePhysical ||
    productType == ProductType.MultipleVirtual;
  const data = {
    moduleContentOrder,
    moduleContentStaticConfig,
    moduleContentDynamicConfig,
    salesChannelProductUuid: uuid,
    collapseErrorMsgDisplay,
    miniProgramShare: miniProgramShare || {},
    miniProgramPageInfo: miniProgramPageInfo || {},
    collapseOpen,
    aliasUuid,
    productName,
    salesChannelName,
    salesChannelUuid,
    contentDetails: {
      sku: skuData.length ? skuData.join(' ') : '',
      productCode: productCode
        ? productCode
        : codeData.length
        ? codeData.join(' ')
        : '',
      productName: aliasProductName,
      productSubtitle: subtitle,
      productRemarks: remarks,
      productDescription: description,
      contentPrice,
      currency: currency,
      // productNameDuplicate: false,
    },
    original,
    hasModified: isNew,
    productType: productType,
    carousel: carouselData,
    seoSetting: seo || generateDefaultSEOSetting(aliasProductName, description),
    thumbnailImage: isMulti ? thumbnailImageData : null,
    contentUuid,
  };
  if (!isNew && hasError) {
    let flag = false;
    const { hasError: seoContentDetails } = validateContentDetails(
      data.contentDetails,
    );
    if (seoContentDetails) {
      data.collapseOpen[EnumCollapseId.contentDetails] = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.contentDetails].hasError =
        true;
      data.collapseErrorMsgDisplay[EnumCollapseId.contentDetails].display =
        true;
      flag = true;
      return data;
    }
    const { hasError: seoErr } = validateSeoSetting(data.seoSetting, isPrimary);
    if (seoErr) {
      data.collapseOpen[EnumCollapseId.seoSetting] = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].hasError = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].display = true;
      flag = true;
      return data;
    }
    const { hasError: carouselErr } = validateCarousel(data.carousel);
    if (carouselErr) {
      data.collapseOpen[EnumCollapseId.carousel] = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.carousel].hasError = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.carousel].display = true;
      flag = true;
      return data;
    }
    const { hasError: thumbnailImageErr } = validateThumbnailImage(
      data.thumbnailImage,
    );
    if (thumbnailImageErr) {
      data.collapseOpen[EnumCollapseId.thumbnailImage] = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.thumbnailImage].hasError =
        true;
      data.collapseErrorMsgDisplay[EnumCollapseId.thumbnailImage].display =
        true;
      flag = true;
      return data;
    }
    initContentError({
      flag,
      moduleContentDynamicConfig,
      _a: data,
      moduleContentOrder,
      moduleContentStaticConfig,
      validationProps: {},
    });
  }
  return data;
};

const convertDataFromReduxToServer = (data) => {
  //alias页面后端不返回contentUuid所以从url里拿
  const {
    contentDetails = {},
    carousel = {},
    thumbnailImage = {},
    seoSetting = {},
    aliasUuid,
    contentUuid = '',
    duplicate,
    moduleContentOrder,
    moduleContentStaticConfig,
    moduleContentDynamicConfig,
    salesChannelUuid,
    miniProgramPageInfo,
    miniProgramShare,
    salesChannelProductUuid,
  } = data;

  const _body = generateBody({
    moduleContentDynamicConfig,
    moduleContentOrder,
    moduleContentStaticConfig,
  });

  const {
    productName,
    productCode,
    productRemarks,
    productSubtitle,
    productDescription,
  } = contentDetails;

  const seoSettingData = seoSetting.customized
    ? seoSetting
    : { ...seoSetting, title: productName, description: productDescription };

  const { staticData = {}, dynamicData = {}, sameAsOriginal } = carousel;

  const {
    moduleName,
    moduleType,
    visible,
    posterType,
    autoPlay,
    intervalTime,
  } = staticData;

  const saveCarousel = {
    moduleName: '',
    moduleType: EnumModuleType.ProductContentCarousel,
    visible: true,
    sameAsOriginal: sameAsOriginal,
    carousel: {
      moduleName,
      moduleType,
      visible,
      posterType,
      autoPlay,
      intervalTime,
      contentLinkModules: dynamicData,
    },
  };

  let saveData = {};

  saveData = {
    contentUuid,
    salesChannelProductUuid,
    productName,
    productCode,
    remarks: productRemarks,
    subtitle: productSubtitle,
    description: productDescription,
    seo: seoSettingData,
    contentModules: _body,
    carousel: saveCarousel,
    uuid: aliasUuid == 'new' ? '' : aliasUuid,
    salesChannelUuid: salesChannelUuid,
    variantThumbnails: thumbnailImage,
    duplicate,
    miniProgramPageInfo,
    miniProgramShare,
  };

  return saveData;
};

const duplicateConvertDataFromReduxToServer = (data) => {
  const {
    uuid,
    salesChannelProductUuid = '',
    contentUuid = '',
    productName,
  } = data;
  return {
    contentUuid,
    uuid: uuid,
    productName,
    salesChannelProductUuid: salesChannelProductUuid,
  };
};

const duplicateConvertDataFromServerToRedux = (response) => {
  const productName = response.productName || '';
  const subtitle = response.subtitle || '';
  const description = response.description || '';
  const remarks = response.remarks || '';
  const carousel = response.carousel || {};
  const longCanvas = response.longCanvas || {};
  const seo = response.seo || {};
  const contentUuid = response.uuid || {};
  const thumbnailImage = response.variantThumbnails;
  const { carousel: carouselServerData, sameAsOriginal } = carousel || {};

  const { product = {}, aliases = [] } = response;
  const { uuid = '', productType = '', products = [], variants = [] } = product;
  const carouselData = calculateCarousel(carouselServerData, sameAsOriginal);
  const skuData = [];
  const codeData = [];
  const thumbnailImageData = {
    sameAsOriginal:
      (thumbnailImage || {}).sameAsOriginal === false ? false : true,
    linkModules: calculateLinkModules(products, thumbnailImage, variants),
  };

  const aliasData = aliases.map((item) => {
    return {
      uuid: item.uuid,
      contentDetails: { productName: item.productName },
      salesChannelProductUuid: uuid,
      contentUuid,
    };
  });
  const data = {
    salesChannelProductUuid: uuid,
    contentDetails: {
      sku: skuData.length ? skuData.join(' ') : '',
      productCode: codeData ? codeData.join(' ') : '',
      productName: productName,
      productSubtitle: subtitle,
      productRemarks: remarks,
      productDescription: description,
    },
    productType: productType,
    carousel: carouselData,
    longCanvas: (longCanvas || {}).linkModules || generateDefaultLongCanvas(),
    seoSetting: seo || generateDefaultSEOSetting(productName, description),
    thumbnailImage: thumbnailImageData,
    contentUuid,
    alias: aliasData || [],
  };
  return data;
};

const validateContentDetails = (pageSetting) => {
  const specificErr = {};
  const { productName } = pageSetting || {};
  specificErr['nameError'] = [];
  if (!productName) {
    specificErr['nameError'].push(
      getI18nFromGeneral('general.error.productNamecannotbeempty'),
    );
  }
  // if (productName && productNameDuplicate) {
  //   specificErr['nameError'].push('A product already exists with the same nam');
  // }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

const validateCarousel = (pageSetting) => {
  const specificErr = {};
  const { dynamicData = [], sameAsOriginal } = pageSetting || {};

  dynamicData.forEach((item, index) => {
    const {
      draggableId,
      linkModule: { linkImage },
    } = item;
    if (!sameAsOriginal && !(linkImage || {}).uuid) {
      specificErr[`${draggableId}_imageError`] = [
        getI18nFromGeneral(
          'general.imageRequireError.theimagefieldcannotbeempty',
        ),
      ];
    }
  });
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

const validateThumbnailImage = (pageSetting) => {
  const specificErr = {};

  ((pageSetting || {}).linkModules || []).forEach((item, index) => {
    const { linkImage = {}, draggableId } = item;
    if (!(linkImage || {}).url || '') {
      specificErr[`${draggableId}_imageError`] = [
        getI18nFromGeneral(
          'general.imageRequireError.theimagefieldcannotbeempty',
        ),
      ];
    }
  });
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

const validateLongCanvas = (pageSetting) => {
  const specificErr = {};
  const generalError = [];
  if (!pageSetting || pageSetting.length == 0) {
    generalError.push(
      getI18nFromGeneral(
        'general.imageRequireError.theimagefieldcannotbeempty',
      ),
    );
  }
  pageSetting.forEach((item) => {
    const { draggableId, linkImage = {}, linkType } = item;
    if (!(linkImage || {}).url) {
      specificErr[`${draggableId}linkImageError`] = [
        getI18nFromGeneral(
          'general.imageRequireError.theimagefieldcannotbeempty',
        ),
      ];
    }
    if (!linkType) {
      specificErr[`${draggableId}linkTypeError`] = ['link cannot be empty'];
    }
  });
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: generalError,
  };
};

const validateSeoSetting = (seoSetting, isPrimary) => {
  const generalError = [];
  const specificErr = {};
  specificErr['slugError'] = [];
  const { slugValid } = seoSetting;
  if (slugValid === false && isPrimary) {
    specificErr['slugError'].push(
      'A page already exists with the same url slug.',
    );
  }

  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError,
  };
};

const calculateCarousel = (carouselServerData, sameAsOriginal?) => {
  const dynamicData = ((carouselServerData || {}).contentLinkModules || []).map(
    (item) => {
      if (!item.draggableId) {
        item.draggableId = randomNumber();
      }
      return item;
    },
  );

  const carouselData = carouselServerData
    ? {
        staticData: {
          posterType: carouselServerData.posterType,
          moduleType:
            carouselServerData.moduleType ||
            EnumModuleType.ProductContentCarousel,
          visible: carouselServerData.visible || false,
          autoPlay: carouselServerData.autoPlay || false,
          intervalTime: carouselServerData.intervalTime || 0,
        },
        dynamicData: dynamicData,
        sameAsOriginal,
      }
    : generateDefaultCarousel();
  return carouselData;
};

const calculateLinkModules = (products, thumbnailImage, variants) =>
  //交换thumbnailImage和products里的数据
  ((thumbnailImage || {}).linkModules || []).map((item) => {
    const productIndex = (products || []).filter(
      (product) => product.uuid == item.uuid,
    );
    const variantsIndex = (variants || []).filter(
      (variant) => variant.productUuid == item.uuid,
    );

    const title = ((productIndex || [])[0] || {}).name;
    const thumbnailUrl = ((productIndex || [])[0] || {}).thumbnailUrl;
    const draggableId = (item || {}).draggableId;
    const linkImage = (item || {}).linkImage;
    return {
      draggableId: draggableId ? draggableId : randomNumber(),
      title: title,
      subtitle: (variantsIndex || [])[0]
        ? ((variantsIndex || [])[0].values || [])
            .map((value) => value.value)
            .join('/')
        : '',
      linkImage: linkImage
        ? linkImage
        : {
            uuid: '',
            url: thumbnailUrl,
          },
      linkType: EnumLinkType.None,
      uuid: item.uuid,
    };
  });

export {
  convertDataFromReduxToServer,
  convertDataFromServerToRedux,
  duplicateConvertDataFromReduxToServer,
  duplicateConvertDataFromServerToRedux,
  validateCarousel,
  validateContentDetails,
  validateLongCanvas,
  validateSeoSetting,
  validateThumbnailImage,
};
